import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  FactorsFetchModel,
  FactorsModel,
  TypeToAvaliacaoModel
} from '../../../../domain/models'
import {
  fetchListAllFactors,
  filterListAllFactors
} from '../../../../main/usecases'

import { goToUrl, formatDate } from '../../../utils'
import { useModalBox, useOnChangeDetect } from '../../../contexts'
import { Button, Table, EmptyData, InputFilter } from '../../../components'
import DeleteFactorModal from './delete-factor'
import FilterCustomFactorModal from './filter-custom-factor'

import {
  PlusSvg,
  IconEditSvg,
  IconTrashSvg
} from '../../../assets/icons/svgComponents'

import * as S from './styles'

export type FilterValuesProps = {
  typeToService: string
  factor: string
}

const Factors = () => {
  const [factors, setFactors] = useState<FactorsFetchModel>()
  const [filterValues, setFilterValues] = useState<FilterValuesProps>()
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const history = useHistory()
  const { modalBox } = useModalBox()
  const alert = useAlert()
  const { refresh } = useOnChangeDetect()

  const handleRemoveFilterFactors = async () => {
    try {
      setFilterValues({ typeToService: '', factor: '' })

      const filterData = await filterListAllFactors({
        typeToService: '',
        factor: '',
        page: page
      }).load()

      setFactors(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao remover filtro', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleFilterFactors = async () => {
    try {
      const filterData = await filterListAllFactors({
        typeToService: filterValues?.typeToService || '',
        factor: filterValues?.factor || '',
        page: page
      }).load()

      setFactors(filterData)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao filtrar', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  const handleClickNewClientRegister = () => {
    modalBox(<FilterCustomFactorModal />, 'Personalize um fator', '38%')
  }

  const columns = useMemo(
    () => [
      {
        Header: 'Nome do fator',
        accessor: 'nameToFactor'
      },
      {
        Header: 'Tipo de Avaliação',
        accessor: 'nameToService'
      },
      {
        Header: 'Data de atualização',
        accessor: 'dataUltimaModificao'
      },
      {
        Header: '',
        accessor: 'actions'
      }
    ],
    []
  )

  const data = useMemo(() => {
    const handleRedirectToRegistrationData = async (
      factor: FactorsModel,
      typeToService: TypeToAvaliacaoModel
    ) => {
      try {
        setLoading(true)

        goToUrl(history, `/fator`, {
          cdFactor: factor && factor.cdFator,
          cdTypeToService: typeToService && typeToService.cdTipoAvaliacao,
          factorTitle: factor && factor.fator,
          serviceTitle: typeToService && typeToService.tipoAvaliacao
        })
      } catch (error) {
        console.error(error)
        alert.show('Erro ao entrar em um fator personalizado', {
          type: 'error',
          timeout: 4000
        })
      } finally {
        setLoading(false)
      }
    }

    const handleOpenDeleteModal = (
      cdTypeToService: number,
      cdFactor: number
    ) => {
      modalBox(
        <DeleteFactorModal
          cdTypeToService={cdTypeToService}
          cdFactor={cdFactor}
        />,
        'Deletar um fator personalizado',
        '32%'
      )
    }
    console.log(factors?.content)

    return factors?.content?.map((item: any) => {
      return {
        nameToFactor: item?.fator.fator,
        nameToService: item?.tipoAvaliacao?.tipoAvaliacao,
        dataUltimaModificao: formatDate(item?.dataUltimaModificacao),
        actions: (
          <div className="table-icons">
            <button
              disabled={loading}
              onClick={() =>
                handleRedirectToRegistrationData(item.fator, item.tipoServico)
              }
              title="Editar"
            >
              <IconEditSvg />
            </button>
            <div
              onClick={() =>
                handleOpenDeleteModal(
                  item.tipoServico.cdTipoAvaliacao,
                  item.fator.cdFator
                )
              }
            >
              <IconTrashSvg />
            </div>
          </div>
        )
      }
    })
  }, [factors?.content, modalBox, loading, alert, history])

  useEffect(() => {
    ;(async () => {
      try {
        const data = await fetchListAllFactors({ page: page }).load()
        setFactors(data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [page, refresh])

  return (
    <S.Wrapper>
      <S.Title>Meus fatores</S.Title>
      <S.CardContainer>
        <S.ActionsContainer>
          <Button
            initialIcon={<PlusSvg />}
            onClick={handleClickNewClientRegister}
          >
            Personalize um fator
          </Button>
          <InputFilter
            name="filter"
            type="text"
            optionsToRadio={[
              { name: 'factor', label: 'Fator' },
              { name: 'typeToService', label: 'Tipo de avaliação' }
            ]}
            placeholder="Pesquisar"
            onFilter={handleFilterFactors}
            onRemove={handleRemoveFilterFactors}
            setFilterValues={setFilterValues}
            filterValues={filterValues}
          />
        </S.ActionsContainer>
        <S.TableContainer>
          {factors && factors?.content?.length ? (
            <Table
              onClick={() => ({})}
              columns={columns}
              dataTable={data}
              handlePageClick={(currentPage: any) =>
                setPage(currentPage.selected + 1)
              }
              pageCount={factors?.totalPages}
            />
          ) : factors?.empty && factors?.content?.length ? (
            <EmptyData>Não há nenhum fator para esse filtro</EmptyData>
          ) : (
            <EmptyData>Personalize um modelo de um fator</EmptyData>
          )}
        </S.TableContainer>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Factors
